export const ProjectDocumentRouting = [
  {
    path: "/work-manage/project-document/library",
    name: "work-manage-project-document-library",
    meta: { title: "项目文档" },
    component: () => import("@/views/work-manage/project-document/library/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/project-document/list",
    name: "work-manage-project-document-list",
    meta: { title: "项目文档" },
    component: () => import("@/views/work-manage/project-document/list/index.vue"),
  },
];
